import React from 'react';
import { Home, Search, Plus, BarChart2, Menu } from 'lucide-react';

const BottomNav = ({ activeTab, setActiveTab, styles }) => {
    return (
        <nav style={styles.bottomNav}>
            <div style={styles.navItem} onClick={() => setActiveTab('home')}>
                <Home size={24} style={activeTab === 'home' ? styles.activeNavItem : {}} />
                <span style={{fontSize: '10px', marginTop: '4px', ...(activeTab === 'home' ? styles.activeNavItem : {})}}>홈</span>
            </div>
            <div style={styles.navItem} onClick={() => setActiveTab('search')}>
                <Search size={24} style={activeTab === 'search' ? styles.activeNavItem : {}} />
                <span style={{fontSize: '10px', marginTop: '4px', ...(activeTab === 'search' ? styles.activeNavItem : {})}}>검색</span>
            </div>
            
            <div style={styles.fabContainer} onClick={() => setActiveTab('add')}>
                <div style={styles.fab}>
                    <Plus size={30} color="#fff" />
                </div>
            </div>

            <div style={styles.navItem} onClick={() => setActiveTab('stats')}>
                <BarChart2 size={24} style={activeTab === 'stats' ? styles.activeNavItem : {}} />
                <span style={{fontSize: '10px', marginTop: '4px', ...(activeTab === 'stats' ? styles.activeNavItem : {})}}>통계</span>
            </div>
            <div style={styles.navItem} onClick={() => setActiveTab('menu')}>
                <Menu size={24} style={activeTab === 'menu' ? styles.activeNavItem : {}} />
                <span style={{fontSize: '10px', marginTop: '4px', ...(activeTab === 'menu' ? styles.activeNavItem : {})}}>메뉴</span>
            </div>
        </nav>
    );
};

export default BottomNav;
